import CommonUtil from '@/common/utils/CommonUtil'
import { Component, Vue } from 'vue-property-decorator'
import Store from '@/common/utils/Store'

import Header from '@/components/layout/header/HeaderNoRegister.vue'
import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'

@Component({
  name: 'C00G1070',
  components: { Header }
  })
export default class C00G1070Controller extends Vue {
  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.init()
  }

  /**
   * 初期処理
   */
  private init() {
    const messageError = JSON.parse(
      SessionStorageService.getItem(CommonConstants.MESSAGE_ERROR)
    )

    if (messageError && messageError.length > 0) {
      messageError.forEach((item) => {
        item.message = item.message?.replaceAll(
          CommonConstants.REGEX_LINE_BREAK,
          '<br/>'
        )

        return {
          ...item
        }
      })

      Store.setResponseErrors(messageError)
    } else {
      Store.setResponseErrors([
        {
          code: 'MSGSYSE0001',
          message: CommonUtil.getMessage('MSGSYSE0001', []),
          url: ''
        }
      ])
    }
  }
}
